import React from "react";
import { FormattedMessage } from "react-intl";
import SportsmenImageNba from "../../Common/Components/SportsmenImageNba.jsx";
import Flag from "../../Common/Components/Flag.jsx";
import useYearGameAchievementsFormatter from "../../utils/useYearGameAchievementsFormatter.js";
import AchievementDetailsModal from "../../TeamDetails/Components/Modal/AchievementDetailsModal.jsx";
import { useState } from "react";

const CSSTransitionGroup = ({ children }) => {
  //todo: use transition group instead
  return children;
};

const ResultDetailsTableNba = ({ details, marked, onDetailsClick, hasShootout, current, result, game }) => {
  if (!details) return null;
  let overtimeString = hasShootout? 'result.overtimeShootout' : 'result.overtime';

  const {formattedAchievements, setAchievements, formattedTypes, setTypes, fetchFromMatch} = useYearGameAchievementsFormatter(game.id);
  const [selectedSides, setSelectedSides] = useState(null);

  const viewAchievementScores = async(sportsmanA, sportsmanB) => {
    sportsmanA['details'] = sportsmanA['score'].toString();
    sportsmanB['details'] = sportsmanB['score'].toString();

    fetchFromMatch(sportsmanA.sportsmanId, sportsmanB.sportsmanId, result.rankingClassificationId, 0, game.sportId);

    setSelectedSides({sideA: sportsmanA, sideB: sportsmanB});
  }

  const onAchievementsDetailsClose = () => {
    setAchievements(null);
    setTypes([]);
    setSelectedSides(null);
  }

  return (
    <>
      <table className="zw-tbl result__details">
        {details.map((detail, key) => (
          <ResultDetailNba
            onDetailsClick={onDetailsClick}
            marked={marked}
            key={key}
            {...detail}
            result={result}
            game={game}
            onAchievementsClick={() => viewAchievementScores(detail['sideA'], detail['sideB'])}
            current={current}
          />
        ))}
        <tbody>
          <tr>
            <td colSpan="10">
              {"* "}
              <FormattedMessage id={overtimeString} />
            </td>
          </tr>
        </tbody>
      </table>

      <CSSTransitionGroup
      transitionName="transition-fade"
      transitionEnterTimeout={500}
      transitionLeaveTimeout={500}
      > 
      {
        result.isNbaAchievementBased &&
        (
          formattedAchievements &&
          selectedSides
        ) ? (
          <AchievementDetailsModal 
            key="1" 
            achievements={formattedTypes}
            details={formattedAchievements} 
            game={game.name}
            onClose={onAchievementsDetailsClose}
            isSingleSportsman={false}
            sidesDetails={selectedSides}
            sportType={game.sportId}
          />
      ) : null}
      </CSSTransitionGroup>
    </>
  );
};
const ResultDetailNba = ({
  sideA,
  sideB,
  marked,
  overtime,
  onDetailsClick,
  onAchievementsClick,
  result
}) => {
  return (
    <tbody 
      role="button"
      className="match-result"
      onClick={(result.isNbaAchievementBased && (sideA && sideB)) && onAchievementsClick}
    >
      <ResultDetailSide
        onDetailsClick={onDetailsClick}
        marked={marked.indexOf(sideA.sportsmanId) !== -1}
        {...sideA}
        overtime={overtime}
      />
      <ResultDetailSide
        onDetailsClick={onDetailsClick}
        marked={marked.indexOf(sideB.sportsmanId) !== -1}
        {...sideB}
        overtime={overtime}
      />
    </tbody>
  );
};

const ResultDetailSide = ({
  name,
  score,
  imageSrc,
  marked,
  overtime,
  country,
  sportsmanId,
  onDetailsClick,
}) => {
  return (
    <tr
      className={
        "details-table__entry match-result-side" +
        (marked ? " match-result-side--marked" : "")
      }
    >
      <td>
        {imageSrc ? (
          <SportsmenImageNba name={name} imageSrc={imageSrc} />
        ) : (
          <Flag code={country} />
        )}
      </td>
      <td>
        <span className="match-result-side__name">{name}</span>
      </td>
      <td
        onClick={() => {
          onDetailsClick(sportsmanId);
        }}
        style={{ cursor: "pointer", color: "#82bc3d", fontWeight: "bold" }}
      >
        <span className="match-result-side__score">{score}</span>
        {overtime ? " *" : null}
      </td>
    </tr>
  );
};

export default ResultDetailsTableNba;
